<template>
  <!--
          作者：long
          时间：2023-08-21
          描述：温泉调查-温泉模板
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="题目">
          <el-input v-model="formInline.search" placeholder="请输入题目"></el-input>
        </el-form-item>
  
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>

        <el-form-item>
          <el-button size="small" @click="addClick">添加</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" @selection-change="handleSelectionChange" border style="width: 100%" v-loading="loading">
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column prop="exam_id" label="ID" ></el-table-column>
          <!-- <el-table-column prop="iamge" label="图片" >
            <template slot-scope="scope">
              <el-image style="width:60px;border-radius: 5px;" :src="scope.row.image"></el-image>
            </template>
          </el-table-column> -->
          <el-table-column prop="code" label="类型" > </el-table-column>
          <el-table-column prop="name" label="题目" ></el-table-column>
          <el-table-column prop="answer" label="答案" ></el-table-column>
          <el-table-column prop="tip" label="提示" ></el-table-column>
          <el-table-column prop="option" label="设置的选项" ></el-table-column>
          <!-- <el-table-column prop="level" label="难度" ></el-table-column> -->
          
          <el-table-column prop="create_time" label="创建时间" ></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row.exam_id)" type="text" size="small" >修改</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small" >删除</el-button>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="curPage"
          :page-sizes="[20, 100,500, 1000]" 
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"></el-pagination>
      </div>
    </div>

    <Add :open="open_add"    @close="closeAdd"></Add>
    <Edit :open="open_edit"  :exam_id="exam_id"   @close="closeAdd"></Edit>
  </div>
</template>

<script>
  import ExamApi from '@/api/exam.js';
  import qs from 'qs';
  import Add from './part/Add.vue';
  import Edit from './part/Edit.vue';
  export default {
    components: {
      Add,
      Edit
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          search: '',

        },
        /*是否打开添加弹窗*/
        open_add: false,
        open_edit:false,
        exam_id:""
    
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
         /*选择数据*/
    handleSelectionChange(e) {
      this.multipleSelection = e;
    },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        
        ExamApi.getData(Params, true)
          .then(res => {
            self.loading = false;
            console.log(res.data)
            self.tableData = res.data.list.data;
            self.totalDataNumber = res.data.list.total;
          })
          .catch(error => {
            self.loading = false;
          });
      },
      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        self.curPage = 1;
        self.getTableList();
      },
      deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          ExamApi.del(
            {
              exam_id: row.exam_id
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，该管理员删除成功',
                  type: 'success'
                });
                //刷新页面
                self.getTableList();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {});
    },
   

    /*打开添加*/
    addClick(e) {
      this.open_add=true;
   
    },
    editClick(e){
      this.open_edit = true;
      this.exam_id = e
    },

    /*关闭添加*/
    closeAdd(e){
      this.open_add = false;
      this.open_edit = false;
      if(e.type=='success'){
        this.getTableList();
      }
    },

    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/plus/exam/question.vue